import { useState, useLayoutEffect } from 'react'

const getBreakpoints = (width) => {
	return {
		loaded: true,
		isDesktop: width > parseInt(1024),
		isTablet: width <= parseInt(1024),
		isMobile: width <= parseInt(768),
	}
}

const useBreakpoint = () => {
	const [breakpoints, setBreakpoints] = useState(getBreakpoints(parseInt(1230)))

	const calcBreakpoints = () => {
		setBreakpoints(getBreakpoints(window.innerWidth))
	}

	useLayoutEffect(() => {
		calcBreakpoints()
		window.addEventListener('resize', calcBreakpoints)
		return () => window.removeEventListener('resize', calcBreakpoints)
	}, [])

	return breakpoints
}

export default useBreakpoint
